import { motion } from "framer-motion";
import { PHONE, PHONE_TEL, EMAIL, OWNER, STREET, CITY } from "../lib/data";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-heading font-bold text-2xl text-white mb-3">{title}</h2>
    <div className="text-white/60 leading-relaxed space-y-3 text-sm md:text-base">{children}</div>
  </div>
);

export default function Legal({ type }) {
  const isImpressum = type === "impressum";
  return (
    <main className="relative pt-40 pb-24 md:pb-32" data-testid={`legal-${type}`}>
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 mb-5">
          <span className="h-px w-10 bg-volt" />
          <span className="text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-volt">Rechtliches</span>
        </div>
        <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
          className="font-heading font-black uppercase tracking-tighter text-4xl md:text-6xl text-white leading-[0.95] mb-12">
          {isImpressum ? "Impressum" : <>Daten<span className="text-volt">schutz</span></>}
        </motion.h1>

        <div className="rounded-2xl bg-ink-surface border border-white/[0.06] p-8 md:p-12">
          {isImpressum ? (
            <>
              <Section title="Angaben gemäß § 5 TMG">
                <p>VoltCore Elektro<br />Inhaberin: {OWNER}<br />{STREET}<br />{CITY}<br />Deutschland</p>
              </Section>
              <Section title="Kontakt">
                <p>Telefon: {PHONE} ({PHONE_TEL})<br />E-Mail: {EMAIL}</p>
              </Section>
              <Section title="Umsatzsteuer">
                <p>Als Kleinunternehmerin im Sinne von § 19 UStG wird keine Umsatzsteuer ausgewiesen.</p>
              </Section>
              <Section title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
                <p>{OWNER}<br />{STREET}, {CITY}</p>
              </Section>
              <Section title="Haftung für Inhalte">
                <p>Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
              </Section>
              <Section title="Haftung für Links">
                <p>Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich.</p>
              </Section>
            </>
          ) : (
            <>
              <Section title="1. Datenschutz auf einen Blick">
                <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
              </Section>
              <Section title="2. Verantwortliche Stelle">
                <p>VoltCore Elektro<br />{OWNER}<br />{STREET}, {CITY}<br />Deutschland<br />Telefon: {PHONE}<br />E-Mail: {EMAIL}</p>
              </Section>
              <Section title="3. Kontaktformular">
                <p>Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b bzw. f DSGVO.</p>
              </Section>
              <Section title="4. Ihre Rechte">
                <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden. Zudem steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p>
              </Section>
              <Section title="5. SSL- bzw. TLS-Verschlüsselung">
                <p>Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am Schloss-Symbol in Ihrer Browserzeile.</p>
              </Section>
            </>
          )}
        </div>
      </div>
    </main>
  );
}
